import react from "react";
import MenuAdmin from "./menuadmin";
export default function DisenoAdmin() {
  return <MenuAdmin />;
}
